@if (ready$ | async) {
  @if (helperService.getIsPwaMode()) {
    <app-pwa [config]="lpConfig"></app-pwa>
  } @else {
    @if (lpConfig) {
      <app-lp [lpConfig]="lpConfig"></app-lp>
    }
  }
}
